import { useMemo } from 'react';
import useCaseByIdQuery from './useCaseByIdQuery';
import usePatientByIdQuery from './usePatientByIdQuery';
import { useBookingContext } from '../lib/context/BookingContext/BookingContext';
import useAppointmentByIdQuery from './useAppointmentByIdQuery';

export const useBookingFlowData = () => {
  const { bookingData } = useBookingContext();

  const { data: existingCaseData } = useCaseByIdQuery(bookingData?.caseId);
  const { data: patientData } = usePatientByIdQuery(bookingData?.patientId);
  const { data: previousAppointmentData } = useAppointmentByIdQuery(bookingData?.previousApptId);

  const newCaseData = bookingData?.newCaseDetails;

  const caseData = useMemo(
    () => (bookingData?.isNewCase ? newCaseData : existingCaseData),
    [bookingData?.isNewCase, existingCaseData, newCaseData]
  );

  return {
    bookingData,
    caseData,
    patientData,
    previousAppointmentData
  };
};

export default useBookingFlowData;
